import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { savingsApi } from "@/lib/savings.api";
import { getApiErrorCode } from "@/lib/api-error";
import { queryKeys } from "@/lib/query-keys";

const ERROR_MESSAGES: Record<string, string> = {
  INVALID_AMOUNT: "Le montant doit être supérieur à zéro.",
  INSUFFICIENT_CREDIT_BALANCE: "Crédit disponible insuffisant pour ce montant.",
  CREDIT_BELOW_INSCRIPTION_FEE:
    "Le montant choisi doit être supérieur aux frais d'inscription pour ouvrir un compte.",
};

interface ConvertCreditParams {
  amount: number;
  responsibleAgentId?: number;
}

export function useConvertCreditToEpargneMutation(partyId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ amount, responsibleAgentId }: ConvertCreditParams) =>
      savingsApi.convertCredit(partyId, amount, responsibleAgentId).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.credits(partyId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.creditLots(partyId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.savings(partyId) });
      toast.success("Crédit converti en épargne.");
    },
    onError: (error) => {
      const code = getApiErrorCode(error);
      toast.error((code && ERROR_MESSAGES[code]) ?? "Erreur lors de la conversion.");
    },
  });
}
